"use client"

import { useId, useState } from "react"
import { useManagedDialog } from "./use-managed-dialog.ts"

export type CatalogSortOrder = "recommended" | "price-asc" | "price-desc"

const options: readonly { readonly label: string; readonly value: CatalogSortOrder }[] = [
  { label: "추천순", value: "recommended" },
  { label: "낮은 가격순", value: "price-asc" },
  { label: "높은 가격순", value: "price-desc" },
]

export const CatalogSortControl = ({ onChange, value }: { readonly onChange: (value: CatalogSortOrder) => void; readonly value: CatalogSortOrder }) => {
  const [open, setOpen] = useState(false)
  const headingId = useId()
  const { cancel, dialogRef, onDialogClose } = useManagedDialog(open, () => setOpen(false))
  const selectedLabel = options.find((option) => option.value === value)?.label ?? "추천순"

  return (
    <>
      <button aria-haspopup="dialog" className="catalog-sort-trigger" onClick={() => setOpen(true)} type="button">
        <span>{selectedLabel}</span>
        <span aria-hidden="true">⌄</span>
      </button>
      <dialog
        aria-labelledby={headingId}
        className="catalog-sort-dialog"
        data-catalog-sort-dialog
        onCancel={(event) => {
          event.preventDefault()
          cancel()
        }}
        onClick={(event) => {
          if (event.target === dialogRef.current) cancel()
        }}
        onKeyDown={(event) => {
          if (event.key !== "Escape") return
          event.preventDefault()
          cancel()
        }}
        onClose={onDialogClose}
        ref={dialogRef}
      >
        <div className="catalog-sort-content">
          <header>
            <h2 id={headingId}>상품 정렬</h2>
            <button aria-label="상품 정렬 닫기" onClick={cancel} type="button">
              ×
            </button>
          </header>
          <div aria-label="정렬 방식" className="catalog-sort-options" role="radiogroup">
            {options.map((option) => (
              <label className="catalog-sort-option" key={option.value}>
                <input
                  checked={value === option.value}
                  name="catalog-sort"
                  onChange={() => {
                    onChange(option.value)
                    cancel()
                  }}
                  type="radio"
                  value={option.value}
                />
                <span>{option.label}</span>
                <span aria-hidden="true" className="catalog-sort-check">
                  {value === option.value ? "✓" : ""}
                </span>
              </label>
            ))}
          </div>
        </div>
      </dialog>
    </>
  )
}
